import styled from 'styled-components';

export const FlashSalesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const CountdownContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  // this fixes the position of the flip clock
  > .flip-clock > div {
    margin-bottom: 0;
  }
`;

export const ExpiredText = styled.span`
  color: white;
`;
